<h4 class='p-y-1' *ngIf="eventId">
    {{event?.name}}</h4>

<div class="row header-container m-b-1 text-xs-center">
    <h4 class='header-title p-a-1'>{{title}}</h4>
</div>